exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.top {\n  width: 100%;\n  background-color: #1b998b;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 99;\n}\n.top ul {\n    list-style: none;\n}\n.top .material-icons {\n    margin: auto;\n    display: inline-block;\n    vertical-align: middle;\n}\n.top a {\n    color: #ffffff;\n    text-decoration: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66521a7e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/TopBar.vue
// module id = VCb0
// module chunks = 15